import { Box, Grid, Typography } from "@mui/material";
import { EmployeeSpend } from "../../components/analytics/EmployeeSpend";
import { CommunicationsBanners } from "../../components/CommunicationsBanners";
import { useData } from "../../utils/useData";
import { TransactionsTable } from "../../components/table/Transactions/TransactionsTable";
import { useState, useEffect } from "react";
import { Transaction } from "../../models";
import { useCustomQuery } from "../../utils/useData";
import { TransactionStatus } from "../../models/transactions/transactionStatus";
import { TransactionType } from "../../models/transactions/transactionType";

// Helper function to get default start date (30 days ago at midnight UTC)
const getDefaultStartDate = (): Date => {
  const date = new Date();
  date.setUTCDate(date.getUTCDate() - 30);
  return new Date(Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    0,
    0,
    0,
    0
  ));
};

export const Home = () => {
  const { employer, userInfoData, employees, accounts, serviceSectors } = useData();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  // Set default start date to 30 days ago
  const defaultStartDate = getDefaultStartDate();

  // Build query string with filters
  const queryString = [
    `employerId=${employer.data?.id}`,
    `page=${page}`,
    `pageSize=${pageSize}`,
    `status=${TransactionStatus.PENDING}`,
    `status=${TransactionStatus.APPROVED}`,
    `status=${TransactionStatus.DECLINED}`,
    `type=${TransactionType.PURCHASE}`,
    `type=${TransactionType.REFUND}`,
    `type=${TransactionType.REIMBURSEMENT}`,
    `fromDate=${defaultStartDate.toISOString()}`
  ].join('&');

  // Fetch transactions with pagination
  const transactions = useCustomQuery<{
    items: Transaction[];
    totalItems: number;
  }>({
    endpoint: `/transactions?${queryString}`,
    options: {
      enabled: !!employer.data?.id
    }
  });

  useEffect(() => {
    transactions.refetch();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize]);

  return (
    <>
      <Box minWidth="fit-content">
        <CommunicationsBanners />
        <Typography variant="subtitle2" sx={{fontWeight: 400, color: "#454545"}}>
          {employer.data?.name ?? ""}
        </Typography>
        <Typography variant="h4" id="welcome-message" data-testid="welcome-message">
          Welcome back, {userInfoData?.user?.firstName}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EmployeeSpend />
          </Grid>
        </Grid>
      </Box>
      <Box marginTop={2}>
        <TransactionsTable
          transactions={transactions.data?.items || []}
          totalItems={transactions.data?.totalItems || 0}
          page={page}
          pageSize={pageSize}
          updatePage={setPage}
          updatePageSize={setPageSize}
          isLoading={transactions.isLoading}
          employerId={employer.data?.id}
          employees={employees.data?.items}
          accounts={accounts.data?.items}
          serviceSectors={serviceSectors.data?.items}
        />
      </Box>
    </>
  );
};
